export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK;
